import { ButtonV2, FormModeV2 } from "../FormControlsV2";

type FormActionsProps = {
  mode: FormModeV2;
  onCancel?: () => void;
};

export function FormActions({ mode, onCancel }: FormActionsProps) {
  if (mode === "readonly") return null;
  return (
    <div className="ov2-property-form__actions">
      {onCancel && (
        <ButtonV2 variant="secondary" onClick={onCancel}>
          Cancelar
        </ButtonV2>
      )}
      <ButtonV2 type="submit">{mode === "edit" ? "Salvar alterações" : "Salvar"}</ButtonV2>
    </div>
  );
}
